<template>
  <el-drawer title="修改密码" :visible.sync="drawer" destroy-on-close :modal-append-to-body="false" append-to-body :wrapperClosable="false" custom-class="widthCommon">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" status-icon label-width="73px" label-position="left" size="small" class="mx-20 bg-#fff py-20 pr-30">
      <el-form-item label="旧密码：" prop="oldPassword">
        <el-input v-angle="loginForm.oldPassword" key="password" v-model="loginForm.oldPassword" type="password" placeholder="请填写旧密码" name="oldPassword" />
      </el-form-item>
      <el-form-item label="新密码：" prop="newPassword">
        <el-input v-angle="loginForm.newPassword" key="password" v-model="loginForm.newPassword" type="password" placeholder="请填写新密码" name="newPassword" />
        <ETips :marginTop="8" padding="0" background="#ffffff" color="#666666" :left="8" text="密码长度为8-16位，需同时包含数字和字母" />
      </el-form-item>
    </el-form>
    <FixedTwoButton activeClass="widthCommon">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import { modifyPassword } from '@/api/user'
import md5 from 'md5'

export default {
  data() {
    return {
      mobilePhone: this.$store.getters.mobilePhone,
      drawer: false,
      loginForm: {
        oldPassword: '',
        newPassword: '',
      },
      loginRules: {
        oldPassword: [{ required: true, trigger: 'blur', message: '旧密码不能为空' }],
        newPassword: [
          { required: true, trigger: 'blur', message: '新密码不能为空' },
          {
            required: true,
            pattern: /^(?=.*[A-Za-z])(?=.*\d)[^]{8,16}$/,
            message: '密码必须包括数字、字母，长度8到16位',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async submitForm() {
      const valid = await this.$refs.loginForm.validate().catch(() => {})
      if (!valid) return false
      const res = await modifyPassword({
        mobilePhone: this.$store.getters.mobilePhone,
        oldPassword: md5(this.loginForm.oldPassword).toUpperCase(),
        newPassword: md5(this.loginForm.newPassword).toUpperCase(),
      })
      if (res.errCode !== 0) return this.$message.error(res.errMsg)
      this.$message.success('修改成功')
      this.drawer = false
    },
    resetForm() {
      this.$refs.loginForm.resetFields()
    },
  },
}
</script>
